import React from 'react';
import classnames from 'classnames';
import GPSelect from '@gp/components/Select';
import { BoolFlag } from '@gp/enums/common';
import { CONSTANT_TEXTS } from '@gp/constants/const';

import type { IBaseProps } from '@home/types/common';

interface IBoolSelectProps extends IBaseProps, IGPSelectProps {}

export const BOOL_OPTIONS: IGPSelectOptionWithGroup[] = [
  { text: CONSTANT_TEXTS.YES, value: BoolFlag.True },
  { text: CONSTANT_TEXTS.NO, value: BoolFlag.False },
];

const BoolSelect: React.FC<IBoolSelectProps> = (props) => {
  const { style, className, ...restProps } = props;

  return (
    <GPSelect
      {...restProps}
      style={style}
      className={classnames('dbg-bool-select', className)}
      options={BOOL_OPTIONS}
    />
  );
};

export default React.memo(BoolSelect);
